import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import BiographySection from "@/components/BiographySection";
import MethodSection from "@/components/MethodSection";
import EcosystemSection from "@/components/EcosystemSection";
import PricingSection from "@/components/PricingSection";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-stone-50" data-testid="home-page">
      <Header />
      <main>
        <HeroSection />
        <BiographySection />
        <MethodSection />
        <EcosystemSection />
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
